export default __webpack_public_path__ + "static/media/pngegg.047927c8.png";